import {actions} from "./Reducer";


export const showContactUserModalAction = (paylaod) => ({
  type: actions.SHOW_MODAL,
  modalType: "CONTACT_USER",
  modalProps: paylaod,
  id: Date.now(),
});

export const hideModalAction = (id) => ({
  type: actions.HIDE_MODAL,
  id: id,
});
